import { Schema, arrayOf } from 'normalizr'

export const detail = new Schema('details')
export const arrayOfDetails = arrayOf(detail)
